/* eslint-disable import/first */
import React from 'react';

export default function OrderHistory(props) {
  return (
    <svg width="30" height="29" viewBox="0 0 30 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.6666 14.5998H14.2666V9.4665H15.7333V13.1332H18.6666V14.5998ZM14.9999 6.53317C10.9563 6.53317 7.66659 9.8229 7.66659 13.8665C7.66659 17.9101 10.9563 21.1998 14.9999 21.1998C19.0435 21.1998 22.3333 17.9101 22.3333 13.8665C22.3333 9.8229 19.0435 6.53317 14.9999 6.53317ZM14.9999 7.99984C18.2354 7.99984 20.8666 10.631 20.8666 13.8665C20.8666 17.102 18.2354 19.7332 14.9999 19.7332C11.7645 19.7332 9.13325 17.102 9.13325 13.8665C9.13325 10.631 11.7645 7.99984 14.9999 7.99984ZM25.2666 24.9926L23.7999 23.526L20.8666 26.4593L17.9333 23.526L14.9999 26.4593L12.0666 23.526L9.13325 26.4593L6.19992 23.526L4.73325 24.9926V2.13317H25.2666V24.9926ZM29.6666 0.666504H0.333252V2.13317H3.26659V28.5332L6.19992 25.5998L9.13325 28.5332L12.0666 25.5998L14.9999 28.5332L17.9333 25.5998L20.8666 28.5332L23.7999 25.5998L26.7333 28.5332V2.13317H29.6666V0.666504Z"
        fill="black"
      />
    </svg>
  );
}
